import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './config/queryClient';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import global Chart.js configuration
import './config/chartConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Use basename-aware path for service worker
    const swVersion = process.env.REACT_APP_VERSION || 'local';
    const swPath = `${process.env.PUBLIC_URL}/service-worker.js?v=${encodeURIComponent(swVersion)}`;
    navigator.serviceWorker.register(swPath, {
      scope: process.env.PUBLIC_URL + '/',
      // Do not let the browser's HTTP cache hide a newer worker script.
      updateViaCache: 'none'
    })
      .then(registration => {
        console.log('SW registered:', registration);
        // Check on every full page load. The script is tiny and the server
        // returns an explicit no-cache policy for this path.
        return registration.update().catch(error => {
          console.log('SW update check failed:', error);
        });
      })
      .catch(error => console.log('SW registration failed:', error));
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
